import styled from 'styled-components';
import { Box, BoxProps } from '@components/Box';
import { themeColor, themeMediaQuery, themeSpace } from '@utils/styledTheme.util';
import { Text } from '@components/typography';
import { JoykitColor } from '@components/themes';

const PAGE_MAX_WIDTH = '1200px';

export const StyledSection = styled(Box)`
  width: 100%;
  padding-left: ${themeSpace(7)};
  padding-right: ${themeSpace(7)};

  ${themeMediaQuery('md')} {
    padding-left: ${themeSpace(10)};
    padding-right: ${themeSpace(10)};
  }

  ${themeMediaQuery('lg')} {
    max-width: ${PAGE_MAX_WIDTH};
    padding-left: 0;
    padding-right: 0;
  }
`;

export const NodesContainer = styled(Box)`
  position: relative;

  h4 {
    margin: ${themeSpace(8)} 0 ${themeSpace(6)};
  }

  p {
    margin: ${themeSpace(4)} 0;
  }

  & > *:first-child {
    margin-top: 0;
  }

  & > *:last-child {
    margin-bottom: 0;
  }
`;

export const StyledTitle = styled(Text)`
  font-weight: 600;
`;

export const StyledButton = styled('button')`
  margin-top: ${themeSpace(6)};
  font-weight: 600;
`;

export const StyledGradient = styled(Box)<{ gradientColor?: JoykitColor }>`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100px;
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0),
    ${({ gradientColor }) => (gradientColor ? themeColor(gradientColor, 1) : 'white')}
  );
`;

export const ReviewsContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: ${themeSpace(8)};
`;

export const ReviewCard = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: ${themeSpace(4)};
`;

export const ReviewHeader = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${themeSpace(4)};
`;

export const ReviewerName = styled(Text)`
  font-weight: 600;
`;

export const ReviewerLocation = styled(Text)`
  font-weight: 400;
  font-style: italic;
`;

export const ReviewStars = styled(Box)`
  display: flex;
  gap: ${themeSpace(1)};
  color: #f5c518;
`;

export const ReviewContent = styled(Text)``;
